export const LOGIN_BUTTON_ID = 'login-button-target';
export const LOGIN_KIT_SDK_URL = 'https://sdk.snapkit.com/js/v1/login.js';
export const SESSION_ID_COOKIE_NAME = 'session_id';
export const AUTH_REDIRECT_COOKIE_NAME = 'auth_redirect';
